import React from 'react';
import { useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { useStyles } from '../styles';
import GiftHistoryTableRow from './GiftHistoryTableRow';


const defaultTableCells = [
  {
    label: 'Id',
    display: true,
  },
  {
    label: 'Action',
    display: true,
  },
  {
    label: 'Balance',
    display: true,
  },
  {
    label: 'Amount Change',
    display: true,
  },
  {
    label: 'Status',
    display: true,
  },
  {
    label: 'Detail',
    display: true,
  },
  {
    label: 'Date and Time',
    display: true,
  },
  {
    label: 'Comment',
    display: true,
  },
];

const GiftHistoryTable = () => {
  const classes = useStyles();
  const {
    giftCardHistory,
    isGiftCardHistoryLoading,
    giftCardHistoryCount,
    selectedGiftCode
  } = useSelector((state: IReduxState) => state.gift_card);


  return (
    <>
      <div className="table-container">
        <TableContainer>
          <Table aria-label="collapsible table" className={classes.table}>
            <TableHead>
              <TableRow>
                {defaultTableCells.map((cell, index) => {
                  if (!cell.display) {
                    return null;
                  }

                  return (
                    <TableCell
                      key={index}
                      className="min-w-80"
                    >
                      {cell.label}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {!giftCardHistoryCount ?
                <TableRow>
                  <TableCell colSpan={Object.keys(defaultTableCells).length + 1} align="center">
                    No matching gift codes found.
                  </TableCell>
                </TableRow>
                :
                giftCardHistory.map((el, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <GiftHistoryTableRow
                      key={el.history_id}
                      giftHistoryData={el}
                      headTableCells={defaultTableCells}
                      selectedGiftCode={selectedGiftCode}
                      labelId={labelId}
                    />
                  );
                })
              }
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <BackdropCircular loading={isGiftCardHistoryLoading} />
    </>
  );
};

export default GiftHistoryTable;
